import To from 'await-to-js'
import encodeUrl from 'encodeurl'
import { wizStandardInstance } from '@/services/instance'
import Callback from './callback'

const ApiMixinDocumentList = {
  async apiDocTree(
    arg = {
      params: {},
    }
  ) {
    let [err, res] = [null, null]
    const listObj = {
      siteId: ' ',
      parentId: ' ',
    }
    if (arg.params) {
      _.assign(listObj, arg.params)
    }
    ;[err, res] = await To(
      wizStandardInstance.get(
        encodeUrl(`/api/folder/gettreesingleasync/${listObj.siteId}/${listObj.parentId}`)
      )
    )
    return Callback.globalCB(err, res)
  },
  async apiExportDocumentListExcl(
    arg = {
      method: '',
      params: {},
      formData: {},
    }
  ) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'importExcelById':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/TagClass/ExportByIdAsync', arg.params)
        )
        break
      case 'exportEmptyExcel':
        ;[err, res] = await To(wizStandardInstance.get('/api/Document/GetEmptyExcelTemplateAsync'))
        break
      default:
        const listObj = {
          id: ' ',
          keWord: ' ',
        }
        if (arg.params) {
          _.assign(listObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(`/api/TagClass/ExportAsync/${listObj.id}/${listObj.keWord}`)
          )
        )
    }
    return Callback.globalCBForOld(err, res)
  },
  async apiDocumentList(
    arg = {
      method: {
        list,
      },
      params: {},
      formData: {},
    }
  ) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'importExcel':
        const importExcelObj = {
          id: ' ',
        }
        if (arg.params && arg.params.id) {
          _.assign(importExcelObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.post(
            `/api/Document/UploadExcelAsync/${importExcelObj.id}`,
            arg.formData
          )
        )
        break
      case 'addTree':
        ;[err, res] = await To(wizStandardInstance.post('/api/folder/addlistasync', arg.params))
        break
      case 'addDocument':
        ;[err, res] = await To(wizStandardInstance.post('/api/document/AddAsync', arg.params))
        break
      case 'setDefaultFile':
        ;[err, res] = await To(
          wizStandardInstance.get(
            `api/std/Document/set-document-default-File?id=${arg.params.id}&fileId=${arg.params.fileId}&standardId=${arg.params.standardId}`
            // `api/document/setdefaultfileasync/${arg.params.id}/${arg.params.fileId}`
          )
        )
        break
      case 'editTree':
        const editTreeObj = {
          id: ' ',
        }
        if (arg.params) {
          _.assign(editTreeObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.put(`/api/std/Folder/${arg.params.id}`, arg.params)
        )
        break
      case 'deleteTree':
        ;[err, res] = await To(wizStandardInstance.delete(`/api/std/Folder/${arg.params.id}`))
        break
      case 'deleteList':
        ;[err, res] = await To(wizStandardInstance.post('/api/Document/DeleteAsync', arg.params.id))
        break
      case 'updateDocumentClass':
        const obj = {
          folderId: ' ',
          documentClassId: ' ',
          isUpdateChild: 1,
          isOnlyUpdateEmptyData: 1,
          documentIds: [],
        }
        if (arg.params) {
          _.assign(obj, arg.params)
        }
        ;[err, res] = await To(wizStandardInstance.post('/api/Document/UpdateDocumentClass', obj))
        break
      case 'listDetail':
        const projectObj = {
          id: ' ',
        }
        if (arg.params) {
          _.assign(projectObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(encodeUrl(`/api/std/Document/${projectObj.id}`))
        )
        break
      case 'tagInfoByFile':
        const tagInfoByFileObj = {
          DocumentId: ' ',
          SkipCount: 1,
          MaxResultCount: 10,
          Keywords: ' ',
          StandardId: '',
        }
        if (arg.params) {
          _.assign(tagInfoByFileObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            `/api/std/TagFileAssociation?DocumentFileId=${tagInfoByFileObj.DocumentFileId}&SkipCount=${tagInfoByFileObj.SkipCount}&MaxResultCount=${tagInfoByFileObj.MaxResultCount}&Keywords=${tagInfoByFileObj.Keywords}&StandardId=${tagInfoByFileObj.StandardId}`
          )
        )
        break
      default:
        const listObj = {
          siteId: ' ',
          folderId: ' ',
          pageNo: 1,
          pageSize: 10,
          orderby: ' ',
          isAsc: true,
          keywords: ' ',
        }
        if (arg.params) {
          _.assign(listObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(
              `/api/Document/GetDocumentListAsync/${listObj.siteId}/${listObj.folderId}/${listObj.pageNo}/${listObj.pageSize}/${listObj.orderby}/${listObj.isAsc}/${listObj.keywords}`
            )
          )
        )
    }
    return Callback.globalCB(err, res, arg.extra)
  },
}
export default {
  methods: ApiMixinDocumentList,
}
